import React from 'react';
import { Redirect } from 'react-router-dom';

import { RouterError } from '~src/bootstrap/routerHelpers/RouterError';
import { Favorites } from '~src/favorites/resources/Favorites';
import { IPublishedConnectionDetailInfo } from '~src/publishedConnection/models/IPublishedConnectionInfo';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';

import { PublishedConnections } from '../resources/PublishedConnections';

export interface PublishedConnectionSpaceFavoriteRedirectProps {
  readonly publishedConnectionId: string;
  readonly urls: SpacesSiteUrls;
}

type PublishedConnectionStatus = 'unfetched' | 'fetched' | 'error';

export const PublishedConnectionSpaceFavoriteRedirect: React.FunctionComponent<PublishedConnectionSpaceFavoriteRedirectProps> = props => {
  const [ publishedConnectionStatus, setPublishedConnectionStatus ] = React.useState<PublishedConnectionStatus>('unfetched');

  React.useEffect(
    () => {
      let didCancel = false;

      fetchPublishedConnection(props.publishedConnectionId)
        .then(() => !didCancel && setPublishedConnectionStatus('fetched'))
        .catch(() => {
          removeFavoritePublishedConnection(props.publishedConnectionId);
          !didCancel && setPublishedConnectionStatus('error');
        });

      return () => didCancel = true;
    },
    [props.publishedConnectionId]
  );

  if (publishedConnectionStatus === 'unfetched') {
    return null;
  } else if (publishedConnectionStatus === 'fetched') {
    return <Redirect to={props.urls.virtualConnectionPath(props.publishedConnectionId)}/>;
  } else {
    return <RouterError errorType={'virtualConnection-removed-favorite'} urls={props.urls} />;
  }
};

async function fetchPublishedConnection(publishedConnectionId: string): Promise<IPublishedConnectionDetailInfo> {
  return PublishedConnections.getById(publishedConnectionId);
}

function removeFavoritePublishedConnection(publishedConnectionId: string) {
  Favorites.remove(publishedConnectionId, 'virtualConnection');
}
